import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {

    const {inputProps, cashInUserConfirm, cashInUserCancel, cashInUserOnChange} = props;
    const {type, show, amount, isFetching} = inputProps;

    return (<SweetAlert
                type={type}
                show={show}
                confirmBtnCssClass={"alert-btn-confirm" + (isFetching ? " disabled" : "")}
                cancelBtnCssClass="alert-btn-cancel"
                showCancel={type === 'success' ? false : true}
                confirmBtnText={type === 'success' ? "Готово" : "Продолжить"}
                cancelBtnText="Отменить"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={'Пополнение баланса'}
                onConfirm={() => cashInUserConfirm()}
                onCancel={() => cashInUserCancel()}
            >
                {
                    <div>
                        <label style={{display:'block'}}>Сумма для пополнения</label>
                        <input
                            type="number"
                            min="0"
                            style={{paddingLeft: '15px',borderRadius: '3px',border: '1px solid #ccc',fontSize: '14px',height: '38px',marginTop: '8px'}}
                            value={amount}
                            onChange={(e) => cashInUserOnChange(e.target.value, "amount")}
                            />
                    </div>    
                }
            </SweetAlert>)
}


// WEBPACK FOOTER //
// ./src/components/Profile/Balance/CashInUserModal.js